import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';
import VeeValidate from 'vee-validate';
import VueMask from 'v-mask';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import BootstrapVue from 'bootstrap-vue';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import VueSimpleSuggest from 'vue-simple-suggest'
import 'vue-simple-suggest/dist/styles.css'; // Optional CSS
import VueRouter from 'vue-router';
import Snotify from 'vue-snotify';
import 'vue-snotify/styles/material.css'

Vue.filter('formatSize', function (value) {
    if (value) {

        if (/^[-][0-9]{1,}.{0,}$/.test(value)) {
            return 'Under ' + value.substring(1).toLowerCase();
        }

        if (/^.{1,}[+].{0,}$/.test(value)) {
            return 'Over ' + value.replace("+", "").toLowerCase();
        }

        if (/^.{1,}[-].{1,}$/.test(value)) {
            return value.toLowerCase();
        }
    }
    return value;
});

Vue.filter('formatDate', function (value) {
    if (value) {
        if (moment(value).year() < moment().year()) {
            return moment(String(value)).format('YYYY');
        }
        return moment(String(value)).format('DD.MM');
    }

    return 'Ukjent'
});

Vue.filter('formatPrice', function (value) {
    if (value > 0) {
        return value.toFixed(2).toString();
    }
    else if (value === 0) {
        return 'fri pris';
    }
    else if (value === -1) {
        return '';
    }
    return 'ukjent';
});

Vue.filter('formatCondition', function (value, conditions) {
    if (value) {
        var condition = conditions.find(element => element.ConditionId === value)
        try {
            var lowercase = '';
            if (condition.LongCondition !== '') {
                lowercase = condition.LongCondition.toLowerCase();
            }
            else {
                lowercase = condition.Condition.toLowerCase();
            }
            return ' - ' + lowercase.charAt(0).toUpperCase() + lowercase.slice(1);
        }
        catch (err) {
            return '';
        }
    }
    return '';
});

Vue.filter('formatName', function (selectedFish) {
    var name = selectedFish.Name
    var longName = selectedFish.LongName
    try {
        var lowercase = '';
        if (longName !== '') {
            lowercase = longName.toLowerCase();
        }
        else {
            lowercase = name.toLowerCase();
        }
        return lowercase.charAt(0).toUpperCase() + lowercase.slice(1);
    }
    catch (err) {
        return '';
    }
});

Vue.filter('capital', function (string) {
    var lowercase = string.toLowerCase();
    try {
        return lowercase.charAt(0).toUpperCase() + lowercase.slice(1);
    }
    catch (err) {
        return string;
    }
});

Vue.filter('formatTitles', function (value) {
    if (value) {
        try {
            if (value !== '') {
                var lowercase = value.toLowerCase();
                return lowercase.charAt(0).toUpperCase() + lowercase.slice(1);
            }
        }
        catch (err) {
            return '';
        }
    }
    return '';
});

//Vue.directive('add-class-hover', {
//    bind(el, binding, vnode) {
//        const { value = "" } = binding;
//        el.addEventListener('mouseenter', () => {
//            el.classList.add(value)
//        });
//        el.addEventListener('mouseleave', () => {
//            el.classList.remove(value)
//        });
//    },
//    unbind(el, binding, vnode) {
//        el.removeEventListener('mouseenter');
//        el.removeEventListener('mouseleave')
//    }
//})


Vue.use(VeeValidate, {
    classes: true,
    classNames: {
        valid: 'is-valid',
        invalid: 'is-invalid'
    }
});

Vue.use(Loading);
Vue.use(VueMask);
Vue.use(BootstrapVue);
Vue.use(VueRouter);
Vue.use(Snotify);

var router = new VueRouter({
    mode: 'history',
    routes: []
});

var mainFish = [102202, 1032, 102701, 2313, 253410, 2524]; // TORSK, SEI, HYSE, BLÅKVEITE, KONGEKREBBE, REKE

var mainConditions = [100, 110, 210, 211]; // SLUH, SLMH, RUND, LEVENDE

var app = new Vue({
    router,
    el: '#minimalPriceData',
    components: {
        VueSimpleSuggest
    },

    data: {
        initialLoaded: false,
        minimalPrices: [],
        filteredPrices: [],
        listOfFish: [],
        selectedSearch: '',
        selectedFish: null,
        selectedFishName: null,
        selectedCondition: null,
        availableConditions: [],
        primaryConditions: [],
        additionalConditions: [],
        additionalConditionSelected: false,
        fishParam: null,

    },

    watch: {
        minimalPrices: function (val) {
            var self = this;
            let fish = self.minimalPrices.map(f => { return { Name: f.Name, NameId: f.NameId, LongName: f.LongName } });
            fish.sort((a, b) => a.Name.localeCompare(b.Name));
            self.listOfFish = fish.filter((v, i, a) => a.findIndex(t => (t.NameId === v.NameId)) === i);

            this.loadCookies();
            //console.log(self.minimalPrices);
        },

        selectedSearch: function (val) {
            this.searchForFish(val);
        },

        selectedFish: function (val) {
            var self = this;
            self.selectedCondition = null;
            if (self.selectedFish !== null) {

                let names = this.minimalPrices.filter(el => el.NameId === val).map(a => a.Name);
                if (names.length > 0) {
                    self.selectedFishName = names[0];
                }
                if (this.availableConditions.length === 1) {
                    this.selectCondition(this.availableConditions[0].ConditionId);
                }
                localStorage.setItem('_rflSelectedFish', self.selectedFish.NameId);
            }
            else {
                self.selectedFishName = null;
                localStorage.setItem('_rflSelectedFish', 0);
                localStorage.setItem('_rflSelectedCond', 0);
            }
        },

        availableConditions: function (val) {
            var self = this;
            self.primaryConditions = [];
            self.additionalConditions = [];

            if (self.availableConditions.length === 0) {
                self.selectedCondition = null;
            }
            else if (self.availableConditions.length > 4) {
                self.primaryConditions = self.availableConditions.filter(ac => mainConditions.includes(ac.ConditionId));
                if (self.primaryConditions.length > 0) {
                    self.additionalConditions = self.availableConditions.filter(ac => !self.primaryConditions.includes(ac));
                }
                else {
                    self.primaryConditions = val;
                }
            }
            else {
                self.primaryConditions = val;
            }

            // colapse additional conditions list on fish type change
            const elem = this.$refs.collapseMainCond
            if (elem && elem.getAttribute('aria-expanded') === 'true') {
                elem.click()
            }
        },

        selectedCondition: function (val) {
            var self = this;
            if (val !== null) {
                self.presentSelected(self.selectedFish.NameId, val);
                localStorage.setItem('_rflSelectedCond', val);

                // expand additional conditions list if one of additional conditions is selected (based on cookies values)
                if (self.additionalConditions.map(a => a.ConditionId).includes(parseInt(val))) {
                    const elem = this.$refs.collapseMainCond
                    if (elem && elem.getAttribute('aria-expanded') === 'false') {
                        elem.click()
                    }
                }
            }
            else {
                self.filteredPrices = [];
                self.additionalConditionSelected = false;
                localStorage.setItem('_rflSelectedCond', 0);
            }
        },

        fishParam: function (val) {
            var elName = 'collapse_' + val;
            const elemToExpand = this.$refs[elName];
            elemToExpand.click()
        },
    },

    computed: {
        listFish() {
            let fish = this.minimalPrices.map(f => { return { Name: f.Name, NameId: f.NameId, LongName: f.LongName } });
            fish.sort((a, b) => a.Name.localeCompare(b.Name));
            return fish.filter((v, i, a) => a.findIndex(t => (t.NameId === v.NameId)) === i);
        },

        primaryFish() {
            if (this.listOfFish.length > 0) {
                var arrayToSort = this.listOfFish.filter(fish => mainFish.includes(fish.NameId))

                return arrayToSort.sort(function (a, b) {
                    return mainFish.indexOf(a.NameId) - mainFish.indexOf(b.NameId);
                });
            }
            return [];
        },

        additionalFish() {
            if (this.listOfFish.length > 0) {
                return this.listOfFish.filter(fish => !mainFish.includes(fish.NameId))
            }
            return [];
        },

        freshAQulity() {
            return this.filteredPrices.filter(f => f.QualityId === 20 && f.ConservationId === 2 && f.SizeId !== 3000000); // A quality, FERSK conservation, size != USPEC
        },

        sluhTorsk() {
            return this.minimalPrices.filter(element =>
                element.ConditionId === 211 && element.NameId === 102202 && element.ConservationId === 2 && element.QualityId === 20 && element.SizeId !== 3000000
            );
        },

        roundTorsk() {
            return this.minimalPrices.filter(element =>
                element.ConditionId === 110 && element.NameId === 102202 && element.ConservationId === 2 && element.QualityId === 20 && element.SizeId !== 3000000
            );
        },

        sluhSei() {
            return this.minimalPrices.filter(element =>
                element.ConditionId === 211 && element.NameId === 1032 && element.ConservationId === 2 && element.QualityId === 20 && element.Size.includes("KG")
            );
        },

        slmhSei() {
            return this.minimalPrices.filter(element =>
                element.ConditionId === 210 && element.NameId === 1032 && element.ConservationId === 2 && element.QualityId === 20 && element.Size.includes("KG")
            );
        },

        roundSei() {
            return this.minimalPrices.filter(element =>
                element.ConditionId === 110 && element.NameId === 1032 && element.ConservationId === 2 && element.QualityId === 20 && element.Size.includes("KG")
            );
        },

        sluhHyse() {
            return this.minimalPrices.filter(element =>
                element.ConditionId === 211 && element.NameId === 102701 && element.ConservationId === 2 && (element.QualityId === 20 || element.QualityId === 12) && element.Size.includes("KG")
            );
        },

        slmhHyse() {
            return this.minimalPrices.filter(element =>
                element.ConditionId === 210 && element.NameId === 102701 && element.ConservationId === 2 && (element.QualityId === 20 || element.QualityId === 12) && element.Size.includes("KG")
            );
        },

        roundHyse() {
            return this.minimalPrices.filter(element =>
                element.ConditionId === 110 && element.NameId === 102701 && element.ConservationId === 2 && (element.QualityId === 20 || element.QualityId === 12) && element.Size.includes("KG")
            );
        },

        krabbe() {
            return this.minimalPrices.filter(element =>
                element.ConditionId === 100 && element.NameId === 253410 && element.ConservationId === 2 && element.QualityId === 20 && (element.SizeId === 4016022 || element.SizeId === 4022032 || element.SizeId === 4032999)
            );
        },

        rognkjeks() {
            return this.minimalPrices.filter(element =>
                element.ConditionId === 110 && element.NameId === 222120 && element.ConservationId === 2 && element.QualityId === 20
            );
        },

    },

    methods: {
        getMinimalPrices: function () {
            let loader = this.$loading.show({
                loader: 'spinner',
                color: '#007bff'
            });
            axios.get('/umbraco/Surface/MinimalPrice/GetMinimalPrices/')
                .then((response) => {
                    if (response.data !== 'error') {
                        this.minimalPrices = response.data;
                        this.initialLoaded = true;
                    }
                    else {
                        console.log('error');
                        this.displayErrorNotification('Databasefeil, vennligst prøv igjen senere.')
                    }
                    loader.hide();

                    setTimeout(() => {
                        this.getUrlParam();
                    }, 500);

                })
                .catch(function (error) {
                    console.log(error);
                    this.displayErrorNotification('Databasefeil, vennligst prøv igjen senere.')
                    loader.hide();
                });
        },

        selectFish: function (fish) {
            if (this.selectedFish === null || this.selectedFish.NameId !== fish.NameId) {
                let conditions = this.minimalPrices.filter(el => el.NameId === fish.NameId).map(a => { return { Condition: a.Condition, LongCondition: a.LongCondition, ConditionId: a.ConditionId } });
                conditions = conditions.filter((v, i, a) => a.findIndex(t => (t.ConditionId === v.ConditionId)) === i)
                this.availableConditions = conditions;

                this.selectedFish = fish;
            }
            else {
                this.selectedFish = null;
                this.selectedSearch = '';
                this.availableConditions = [];
            }
        },

        selectCondition: function (conditionCode, collapseMainList = false) {
            if (this.selectedCondition !== conditionCode) {
                this.selectedCondition = conditionCode;
                if (collapseMainList) {
                    this.collapseMainTypes();
                }
            }
            else {
                this.selectedCondition = null;
            }
        },

        getFishNames: function () {
            let fishNames = this.minimalPrices.map(f => f.Name);
            fishNames = [...new Set(fishNames)];

            return fishNames;
        },

        searchForFish: function (searchString) {
            var self = this;

            if (searchString !== '') {
                let found = self.listFish.filter(element => element.LongName === searchString);
                found = found[0]

                if (found) {
                    self.selectFish(found);

                    const elem = this.$refs.colapse0
                    if (elem.getAttribute('aria-expanded') === 'false') {
                        elem.click()
                    }
                }
            }
        },

        presentSelected: function (fishCode, conditionCode) {
            var self = this;
            self.filteredPrices = self.minimalPrices.filter(element =>
                element.ConditionId === conditionCode && element.NameId === fishCode
            );
        },

        makeToast(title, body, variant) {
            this.$bvToast.toast(body, {
                title: title,
                variant: variant,
                solid: true
            });
        },

        getFilteredList(nameId, conditionId, conservations = [], qualities = [], showUnspecifiedWeight = false) {
            var conservationsList = conservations.split(";").map(Number);
            var qualitiesList = qualities.split(";").map(Number);

            var listToReturn = [];

            if (conservationsList.length > 0 && qualitiesList.length > 0) {
                listToReturn = this.minimalPrices.filter(element =>
                    element.NameId === nameId && element.ConditionId === conditionId && conservationsList.includes(element.ConservationId) && qualitiesList.includes(element.QualityId)
                );
            }
            else if (conservationsList.length > 0) {
                listToReturn = this.minimalPrices.filter(element =>
                    element.NameId === nameId && element.ConditionId === conditionId && conservationsList.includes(element.ConservationId)
                );
            }
            else if (qualitiesList.length > 0) {
                listToReturn = this.minimalPrices.filter(element =>
                    element.NameId === nameId && element.ConditionId === conditionId && qualitiesList.includes(element.QualityId)
                );
            }
            else {
                listToReturn = this.minimalPrices.filter(element =>
                    element.NameId === nameId && element.ConditionId === conditionId
                );
            }

            if (!showUnspecifiedWeight) {
                return listToReturn.filter(element => element.SizeId !== 3000000);
            }
            else {
                return listToReturn;
            }
        },

        getFishName(nameId) {
            var self = this;
            var fish = self.minimalPrices.find(element =>
                element.NameId === nameId
            );
            if (fish === undefined) {
                return '';
            }

            return fish;
        },

        loadCookies() {
            var self = this;
            var cookieSelectedFish = localStorage.getItem('_rflSelectedFish');
            var cookieSelectedCond = localStorage.getItem('_rflSelectedCond');

            if (cookieSelectedFish && cookieSelectedFish !== '0') {
                var fishToSelect = self.listOfFish.find(fish => fish.NameId.toString() === cookieSelectedFish);

                if (fishToSelect !== null) {
                    self.selectFish(fishToSelect);

                    if (cookieSelectedCond && cookieSelectedCond !== '0' && self.selectedFish !== null) {
                        setTimeout(() => {
                            self.selectCondition(parseInt(cookieSelectedCond));
                        }, 1000);
                    }
                }
            }
        },

        collapseMainTypes() {
            var filteredRefs = Object.keys(this.$refs).filter((ref) => {
                if (ref.includes('collapse_')) {
                    return true
                }
                return false
            }).map((val) => { return this.$refs[val] })
            filteredRefs.forEach(function (element) {
                if (element.getAttribute('aria-expanded') === 'true') {
                    element.click()
                }
            });
        },

        filterClick() {
            var elem = this.$refs.colapse0
            setTimeout(() => {
                if (elem && elem.getAttribute('aria-expanded') === 'true') {
                    this.collapseMainTypes()
                }
            }, 300);
        },

        getUrlParam() {
            var parameters = this.$route.query
            if (parameters && parameters.fishType) {
                this.fishParam = parameters.fishType;
            }
        },

        displayErrorNotification(error) {
            this.$snotify.error(error, {
                timeout: 5000,
                showProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true
            });
        },
    },

    mounted() {
        this.getMinimalPrices();

        this.$nextTick(() => {

        });

    }
});


// WEBPACK FOOTER //
// ./Scripts/app/minimalPrice/index.js